<mat-toolbar>Edit department / workarea</mat-toolbar>
<div class="Dialog-body">
  <form>
<!--     
    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input type="text" matInput placeholder="Department" [(ngModel)]="selectedDepartment" [ngModelOptions]="{standalone: true}">
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input type="text" matInput placeholder="Workarea" [(ngModel)]="selectedWorkarea" [ngModelOptions]="{standalone: true}">
    </mat-form-field> -->

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <mat-select placeholder="Department" (selectionChange) = "GetActiveWorkAreasForDropDownListChanged()"  [(ngModel)]="inputValueDepartment" name="Department">            
        <mat-option *ngFor="let Department of departmentlist" [value]="Department.ID">
          {{Department.DepartmentName}} </mat-option>
        </mat-select> 
    </mat-form-field>

  
    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <mat-select placeholder="{{'Work Area'}}"   [(ngModel)]="inputValueWorkArea" name="Workarea" [(ngModel)]="inputValueWorkArea">            
        <mat-option *ngFor="let Workarea of WorkList" [value]="Workarea.Id">
          {{Workarea.Name}} </mat-option>
        </mat-select> 
    </mat-form-field>

      <div class="buttonbelow">
        <button mat-button (click) = "save()">Submit</button>
        <button mat-button  (click)="DialogClose()" >Cancel</button>    
      </div>
  </form>

</div>
